/**
 * Экраны, у которых есть постоянный родитель, а не «шаг назад по истории».
 *
 * Системная «Назад» по умолчанию отматывает историю. Для переписки это неверно: открыть её можно
 * из списка чатов, с главной, из профиля собеседника и по уведомлению - и в трёх случаях из
 * четырёх «Назад» уводила куда угодно, только не в список переписок. Человек нажимал её, чтобы
 * выйти из разговора, а попадал на главную, где внизу снова подсвечивался «Home».
 *
 * Поэтому экран может сказать: «у меня есть родитель, и уходить надо к нему». Хранится это
 * стопкой, а не одним местом: экраны монтируются и размонтируются вперемешку (окно поверх
 * переписки), и уход верхнего не должен снимать обработчик нижнего. Отвечает всегда верхний.
 *
 * Ничего не знает ни про роутер, ни про React: этим модулем пользуются и хук экрана, и слушатель
 * кнопки, который живёт в корне дерева и про экраны знать не обязан.
 */
type BackHandler = () => void;

const stack: BackHandler[] = [];

export const hasNativeBackHandler = (): boolean => stack.length > 0;

/** @returns снятие; снимает именно свой обработчик, где бы он к тому моменту ни оказался. */
export const pushNativeBackHandler = (handler: BackHandler): (() => void) => {
  stack.push(handler);
  if (typeof window !== 'undefined')
    window.dispatchEvent(new Event('teamplay:native-back-handler-change'));

  return () => {
    const index = stack.lastIndexOf(handler);
    if (index >= 0) {
      stack.splice(index, 1);
      if (typeof window !== 'undefined')
        window.dispatchEvent(new Event('teamplay:native-back-handler-change'));
    }
  };
};

/** @returns было ли кому ответить. `false` - «Назад» работает как раньше, по истории. */
export const runNativeBackHandler = (): boolean => {
  const handler = stack.at(-1);
  if (!handler) {
    return false;
  }

  handler();
  return true;
};

/** Только для тестов: стопка пуста, как при первом запуске. */
export const resetNativeBackStackForTests = (): void => {
  stack.length = 0;
};
